import { CheckOutlined, CloseOutlined, MinusOutlined } from "@ant-design/icons";
import { Radio } from "antd";
import React from "react";
import { $t } from "~/i18n.js";
import { colors } from "~/theme/colors.js";

export const ReservationStatusButtons = ({ value, onChange }) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <Radio.Group
      value={value}
      onChange={handleChange}
      buttonStyle="solid"
      optionType="button"
      style={{ marginBottom: 16 }}
    >
      <Radio.Button value="accepted">
        <CheckOutlined /> {$t("accepted")}
      </Radio.Button>
      <Radio.Button value="tentative">
        <MinusOutlined /> {$t("tentative")}
      </Radio.Button>
      <Radio.Button value="rejected">
        <CloseOutlined /> {$t("rejected")}
      </Radio.Button>
    </Radio.Group>
  );
};
